export default {
  section1: [
    {
      name: "geo",
      label: "Region",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select Region",
      key: "pg1_1",
      label_lang: "OnbrdProfileRegion",
      useLabel: true,
      actions: [
        {
          fieldName: "billingCountry",
          func: "regionAction",
          resetRequired: true,
          resetValue: "",
        },
        {
          fieldName: "preferredLanguage_0",
          func: "none",
          resetRequired: true,
          resetValue: "",
        },
      ],
    },
    {
      name: "billingCountry",
      label: "Country",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select Country",
      key: "pg1_2",
      useLabel: true,
      label_lang: "OnbrdProfileCountry",
      actions: [
        {
          fieldName: "preferredLanguage_0",
          func: "countryAction",
          resetRequired: true,
          resetValue: "",
        },
        {
          fieldName: "billingState",
          func: "none",
          resetRequired: true,
          resetValue: "",
        },
      ],
    },
    {
      name: "preferredLanguage_0",
      label: "Language",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select Language",
      key: "pg1_3",
      useLabel: true,
      label_lang: "OnbrdContactPrefLang",
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
        {
          fieldName: "billingCountry",
          func: "setLanguageReg",
        },
      ],
    },
  ],
  section2: [
    {
      name: "iCertify",
      label: "I certify that I am either :",
      label_lang: "i_certify",
      type: "checkbox",
      required: true,
      renderLabel: false,
      useLabel: true,
      fieldLableProps: {
        position: "right",
      },
      key: "pg2_1",
    },
  ],
  section3: [
    {
      name: "name",
      label: "Company Name *",
      type: "textfield",
      maxLength: 255,
      required: true,
      placeholder: "Enter your company name",
      validator: "disallowDomainValidationForString",
      key: "pg3_1",
      label_lang: "OnbrdProfileFullCompName",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "bizRegistrationNum",
      label: "Business Registration Number *",
      type: "textfield",
      maxLength: 80,
      required: true,
      placeholder: "Enter your business registration number",
      key: "pg3_2",
      label_lang: "OnbrdProfileBRN",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "dateFounded",
      label: "Year Established *",
      type: "textfield",
      maxLength: 4,
      required: true,
      validator: "isYear",
      placeholder: "Enter your year established",
      key: "pg3_3",
      label_lang: "OnbrdProfileYrIncorp",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section4: [
    {
      name: "tradingName",
      label: "Trading Name",
      type: "textfield",
      maxLength: 80,
      placeholder: "Enter your trading name",
      key: "pg3_4",
      label_lang: "OnbrdProfileTradingName",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredDistributor",
      label: "Preferred Distributor",
      type: "textfield",
      maxLength: 255,
      placeholder: "Enter your preferred distributor",
      key: "pg3_5",
      label_lang: "OnbrdProfilePreferredDistributor",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyType",
      label: "Company Type(select all that apply)*",
      type: "select",
      required: true,
      multiple: true,
      validator: "isValidList",
      placeholder: "Select company type(s)",
      key: "pg3_6",
      label_lang: "OnbrdProfileCompType",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      options: [
        {
          label: "Large Account Reseller (LAR)",
          value: "Large Account Reseller (LAR)",
        },
        {
          label: "Value Added Reseller (VAR)",
          value: "Value Added Reseller (VAR)",
        },
        {
          label: "Systems Integrator (SI)",
          value: "Systems Integrator (SI)",
        },
        {
          label: "Independent Software Vendor (ISV)",
          value: "Independent Software Vendor (ISV)",
        },
        {
          label: "Original Equipment Manufacturer (OEM)",
          value: "Original Equipment Manufacturer (OEM)",
        },
        {
          label: "Consulting Firm",
          value: "Consulting Firm",
        },
        {
          label: "Service(s) Provider",
          value: "Service(s) Provider",
        },
        {
          label: "Authorized Distributor",
          value: "Authorized Distributor",
        },
        {
          label: "Online Retailer",
          value: "Online Retailer",
        },
        {
          label: "Retail Partner",
          value: "Retail Partner",
        },
      ],
    },
  ],
  section5: [
    {
      name: "billingStreet",
      label: "Street *",
      type: "textfield",
      maxLength: 255,
      required: true,
      validator: "isString",
      placeholder: "Enter your address",
      key: "pg3_7",
      label_lang: "OnbrdProfileStreet",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingState",
      label: "State/Province *",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "State/Province",
      key: "pg3_8",
      label_lang: "OnbrdProfileState",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "setStateType",
        },
      ],
    },
    {
      name: "countryLable",
      label: "Country *",
      type: "textfield",
      disabled: true,
      validator: "isString",
      label_lang: "OnbrdProfileCountry",
      key: "pg3_9",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "setCountryLabel",
        },
      ],
    },
  ],
  section6: [
    {
      name: "billingCity",
      label: "City *",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "City",
      key: "pg3_10",
      label_lang: "OnbrdProfileCity",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingPostalCode",
      label: "Postal Code *",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "Postal Code",
      key: "pg3_11",
      label_lang: "OnbrdProfilePostCode",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section7: [
    {
      name: "companyPhone",
      label: "Primary Phone *",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter the primary phone number",
      label_lang: "OnbrdProfilePrimPhone",
      key: "pg3_12",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyEmail",
      label: "Company E-mail Address *",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      placeholder: "Enter your company e-mail address",
      label_lang: "comp_email_address",
      key: "pg3_13",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "secondaryUrl",
      label: "Secondary Website",
      type: "textfield",
      maxLength: 255,
      validator: "isValidWebsite",
      placeholder: "Enter a secondary website URL",
      label_lang: "OnbrdProfileSecondaryURL",
      key: "pg3_14",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section8: [
    {
      name: "fax",
      label: "Fax",
      type: "textfield",
      placeholder: "Enter the fax machine number",
      label_lang: "OnbrdProfilePrimFax",
      key: "pg3_15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "primaryUrl",
      label: "Website URL *",
      type: "textfield",
      maxLength: 255,
      required: true,
      validator: "isValidWebsite",
      placeholder: "Enter your company website URL",
      label_lang: "OnbrdProfilePrimURL",
      key: "pg3_16",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section9: [
    {
      name: "prefix_0",
      label: "Prefix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the prefix",
      validator: "prefixContactField",
      label_lang: "OnbrdContactPrefix",
      key: "pg1ac1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "suffix_0",
      label: "Suffix/Title",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the suffix/title",
      validator: "suffixContactField",
      label_lang: "OnbrdContactTitle",
      key: "pg1ac2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "firstName_0",
      label: "First Name *",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      label_lang: "OnbrdContactFName",
      key: "pg4_1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName_0",
      label: "Last Name *",
      type: "textfield",
      maxLength: 80,
      required: true,
      validator: "isString",
      label_lang: "OnbrdContactLName",
      key: "pg4_5",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredLanguage_0",
      label: "Preferred Language *",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a language",
      options: [],
      label_lang: "OnbrdContactPrefLang",
      key: "pg4_4",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
        {
          fieldName: "billingCountry",
          func: "setLanguageReg",
        },
      ],
    },
  ],
  section10: [
    {
      name: "phone_0",
      label: "Phone Number *",
      type: "textfield",
      validator: "isValidPhoneNumber",
      required: true,
      placeholder: "Enter your phone number",
      label_lang: "OnbrdContactPhone",
      key: "pg4_6",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email_0",
      label: "E-mail Address *",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      label_lang: "OnbrdProfileContactEmail",
      key: "pg4_2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "jobRole_0",
      label: "Job Role *",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a job role",
      options: [
        {
          label: "Accounting",
          value: "Accounting",
        },
        {
          label: "Administration",
          value: "Administration",
        },
        {
          label: "Development",
          value: "Development",
        },
        {
          label: "Executive",
          value: "Executive",
        },
        {
          label: "Finance",
          value: "Finance",
        },
        {
          label: "Helpdesk Support",
          value: "Helpdesk Support",
        },
        {
          label: "IT",
          value: "IT",
        },
        {
          label: "Marketing",
          value: "Marketing",
        },
        {
          label: "Owner",
          value: "Owner",
        },
        {
          label: "Partner Specialist",
          value: "Partner Specialist",
        },
        {
          label: "PR/Communications",
          value: "PR/Communications",
        },
        {
          label: "Professional Services",
          value: "Professional Services",
        },
        {
          label: "Sales Representative",
          value: "Sales Representative",
        },
        {
          label: "Sales Management",
          value: "Sales Management",
        },
        {
          label: "System/Pre-sales Engineer",
          value: "System/Pre-sales Engineer",
        },
        {
          label: "Technical Support",
          value: "Technical Support",
        },
        {
          label: "Training",
          value: "Training",
        },
        {
          label: "Web Administration/Master",
          value: "Web Administration/Master",
        },
      ],
      label_lang: "OnbrdContactJRole",
      key: "pg4_3",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "additionalContactType_0",
      label: "Contact Type(select all that apply) *",
      type: "select",
      required: true,
      validator: "isValidList",
      placeholder: "Select contact type(s)",
      options: [
        {
          label: "Lead Sales",
          value: "Lead Sales",
        },
        {
          label: "Lead Marketing",
          value: "Lead Marketing",
        },
        {
          label: "Lead Technical",
          value: "Lead Technical",
        },
        {
          label: "Sales Information",
          value: "Sales Information",
        },
        {
          label: "Marketing Information",
          value: "Marketing Information",
        },
        {
          label: "Technical Information",
          value: "Technical Information",
        },
        {
          label: "Security Information",
          value: "Security Information",
        },
        {
          label: "Events and Promotional Offers",
          value: "Events and Promotional Offers",
        },
        {
          label: "General Information",
          value: "General Information",
        },
        {
          label: "Standard User",
          value: "Standard User",
        },
      ],
      multiple: true,
      label_lang: "contact_type",
      key: "pg4_7",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section11: [
    {
      name: "prefix_1",
      label: "Prefix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the prefix",
      validator: "prefixContactField",
      label_lang: "OnbrdContactPrefix",
      key: "pg1ac1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "suffix_1",
      label: "Suffix/Title",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the suffix/title",
      validator: "suffixContactField",
      label_lang: "OnbrdContactTitle",
      key: "pg1ac2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "firstName_1",
      label: "First Name *",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "First name",
      label_lang: "OnbrdContactFName",
      key: "pg4_8",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName_1",
      label: "Last Name *",
      type: "textfield",
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Last name",
      label_lang: "OnbrdContactLName",
      key: "pg4_12",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredLanguage_1",
      label: "Primary Language *",
      label_lang: "OnbrdContactPrefLang",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a language",
      options: [],
      key: "pg4_11",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
      ],
    },
  ],
  section12: [
    {
      name: "phone_1",
      label: "Phone Number *",
      label_lang: "OnbrdContactPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter your phone number",
      key: "pg4_13",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email_1",
      label: "E-mail Address *",
      label_lang: "OnbrdProfileContactEmail",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      placeholder: "E-mail address",
      key: "pg4_9",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "jobRole_1",
      label: "Job Role *",
      label_lang: "OnbrdContactJRole",
      type: "select",
      required: true,
      validator: "isValidList",
      placeholder: "Select a job role",
      options: [
        {
          label: "Accounting",
          value: "Accounting",
        },
        {
          label: "Administration",
          value: "Administration",
        },
        {
          label: "Development",
          value: "Development",
        },
        {
          label: "Executive",
          value: "Executive",
        },
        {
          label: "Finance",
          value: "Finance",
        },
        {
          label: "Helpdesk Support",
          value: "Helpdesk Support",
        },
        {
          label: "IT",
          value: "IT",
        },
        {
          label: "Marketing",
          value: "Marketing",
        },
        {
          label: "Owner",
          value: "Owner",
        },
        {
          label: "Partner Specialist",
          value: "Partner Specialist",
        },
        {
          label: "PR/Communications",
          value: "PR/Communications",
        },
        {
          label: "Professional Services",
          value: "Professional Services",
        },
        {
          label: "Sales Representative",
          value: "Sales Representative",
        },
        {
          label: "Sales Management",
          value: "Sales Management",
        },
        {
          label: "System/Pre-sales Engineer",
          value: "System/Pre-sales Engineer",
        },
        {
          label: "Technical Support",
          value: "Technical Support",
        },
        {
          label: "Training",
          value: "Training",
        },
        {
          label: "Web Administration/Master",
          value: "Web Administration/Master",
        },
      ],
      key: "pg4_10",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "additionalContactType_1",
      label: "Contact Type(select all that apply) *",
      label_lang: "contact_type",
      type: "select",
      required: true,
      validator: "isValidList",
      placeholder: "Select contact type(s)",
      options: [
        {
          label: "Lead Sales",
          value: "Lead Sales",
        },
        {
          label: "Lead Marketing",
          value: "Lead Marketing",
        },
        {
          label: "Lead Technical",
          value: "Lead Technical",
        },
        {
          label: "Sales Information",
          value: "Sales Information",
        },
        {
          label: "Marketing Information",
          value: "Marketing Information",
        },
        {
          label: "Technical Information",
          value: "Technical Information",
        },
        {
          label: "Security Information",
          value: "Security Information",
        },
        {
          label: "Events and Promotional Offers",
          value: "Events and Promotional Offers",
        },
        {
          label: "General Information",
          value: "General Information",
        },
        {
          label: "Standard User",
          value: "Standard User",
        },
      ],
      multiple: true,
      key: "pg4_14",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section13: [
    {
      name: "prefix",
      label: "Prefix",
      label_lang: "OnbrdContactPrefix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the prefix",
      validator: "prefixContactField",
      key: "pg1ac1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "suffix",
      label: "Suffix/Title",
      label_lang: "OnbrdContactTitle",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the suffix/title",
      validator: "suffixContactField",
      key: "pg1ac2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "firstName",
      label: "First Name *",
      label_lang: "OnbrdContactFName",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "First name",
      key: "pg4_15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName",
      label: "Last Name *",
      label_lang: "OnbrdContactLName",
      type: "textfield",
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Last name",
      key: "pg4_19",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredLanguage",
      label: "Primary Language *",
      label_lang: "OnbrdContactPrefLang",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a language",
      options: [],
      key: "pg4_18",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
      ],
    },
  ],
  section14: [
    {
      name: "phone",
      label: "Phone Number *",
      label_lang: "OnbrdContactPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter your phone number",
      key: "pg4_20",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email",
      label: "E-mail Address *",
      label_lang: "OnbrdProfileContactEmail",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      placeholder: "E-mail address",
      key: "pg4_16",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "jobRole",
      label: "Job Role *",
      label_lang: "OnbrdContactJRole",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a job role",
      options: [
        {
          label: "Accounting",
          value: "Accounting",
        },
        {
          label: "Administration",
          value: "Administration",
        },
        {
          label: "Development",
          value: "Development",
        },
        {
          label: "Executive",
          value: "Executive",
        },
        {
          label: "Finance",
          value: "Finance",
        },
        {
          label: "Helpdesk Support",
          value: "Helpdesk Support",
        },
        {
          label: "IT",
          value: "IT",
        },
        {
          label: "Marketing",
          value: "Marketing",
        },
        {
          label: "Owner",
          value: "Owner",
        },
        {
          label: "Partner Specialist",
          value: "Partner Specialist",
        },
        {
          label: "PR/Communications",
          value: "PR/Communications",
        },
        {
          label: "Professional Services",
          value: "Professional Services",
        },
        {
          label: "Sales Representative",
          value: "Sales Representative",
        },
        {
          label: "Sales Management",
          value: "Sales Management",
        },
        {
          label: "System/Pre-sales Engineer",
          value: "System/Pre-sales Engineer",
        },
        {
          label: "Technical Support",
          value: "Technical Support",
        },
        {
          label: "Training",
          value: "Training",
        },
        {
          label: "Web Administration/Master",
          value: "Web Administration/Master",
        },
      ],
      key: "pg4_17",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "additionalContactType",
      label: "Contact Type(select all that apply) *",
      type: "select",
      label_lang: "contact_type",
      required: true,
      validator: "isValidList",
      placeholder: "Select contact type(s)",
      options: [
        {
          label: "Lead Sales",
          value: "Lead Sales",
        },
        {
          label: "Lead Marketing",
          value: "Lead Marketing",
        },
        {
          label: "Lead Technical",
          value: "Lead Technical",
        },
        {
          label: "Sales Information",
          value: "Sales Information",
        },
        {
          label: "Marketing Information",
          value: "Marketing Information",
        },
        {
          label: "Technical Information",
          value: "Technical Information",
        },
        {
          label: "Security Information",
          value: "Security Information",
        },
        {
          label: "Events and Promotional Offers",
          value: "Events and Promotional Offers",
        },
        {
          label: "General Information",
          value: "General Information",
        },
        {
          label: "Standard User",
          value: "Standard User",
        },
      ],
      multiple: true,
      key: "pg4_22",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section15: [
    {
      name: "iAgree",
      label:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      label_lang: "prog_agmt_checkbox",
      type: "checkbox",
      key: "pg5_1",
      required: true,
      renderLabel: false,
      fieldLableProps: {
        position: "left",
        style: {
          width: "90%",
          float: "right",
        },
      },
      useLabel: true,
    },
  ],
};
